import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import { ReactComponent as ExclamationCircle } from 'assets/images/exclamation-circle.svg';

export const ExclamationCircleIcon = styled(ExclamationCircle)`
  width: 24px;
  height: 24px;
  color: ${ColorPalette.HEX.OrangeWeb};
  margin: 32px 24px 0;
`;
